'use client'

import { type ReactNode, createContext, useContext, useState } from 'react'

interface ChartExpandedContextValue {
  isChartExpanded: boolean
  setChartExpanded: React.Dispatch<React.SetStateAction<boolean>>
}

const ChartExpandedContext = createContext<ChartExpandedContextValue | null>(
  null,
)

export function ChartExpandedProvider({ children }: { children: ReactNode }) {
  const [isChartExpanded, setChartExpanded] = useState(false)

  return (
    <ChartExpandedContext.Provider
      value={{ isChartExpanded, setChartExpanded }}
    >
      {children}
    </ChartExpandedContext.Provider>
  )
}

export function useChartExpanded(): ChartExpandedContextValue {
  const context = useContext(ChartExpandedContext)
  if (!context) {
    throw new Error(
      'useChartExpanded must be used within a ChartExpandedProvider',
    )
  }
  return context
}
